import { render, staticRenderFns } from "./batchAppendix.vue?vue&type=template&id=54b610de&scoped=true"
import script from "./batchAppendix.vue?vue&type=script&lang=js"
export * from "./batchAppendix.vue?vue&type=script&lang=js"
import style0 from "./batchAppendix.vue?vue&type=style&index=0&id=54b610de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b610de",
  null
  
)

export default component.exports